import type { AgentRoom } from "./nav.js";

type Props = {
	agent: Pick<AgentRoom, "name" | "initials" | "avatar" | "avatar2x">;
	size?: "sm" | "md" | "lg" | "xl";
};

const SIZE_PX = { sm: 28, md: 36, lg: 72, xl: 200 } as const;

/** Persona mark — photo when present, brand-tinted initials otherwise. */
export function AgentAvatar({ agent, size = "sm" }: Props) {
	const className = `agent-avatar agent-avatar--${size}`;
	const px = SIZE_PX[size];
	if (agent.avatar) {
		return (
			<img
				className={className}
				src={agent.avatar}
				srcSet={
					agent.avatar2x
						? `${agent.avatar} 1x, ${agent.avatar2x} 2x`
						: undefined
				}
				alt=""
				width={px}
				height={px}
				draggable={false}
			/>
		);
	}
	return (
		<span className={className} aria-hidden>
			{agent.initials}
		</span>
	);
}
